import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { Spinner } from "@material-tailwind/react";
import GalleryLayout from "./layout/GalleryLayout.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import AnonymousRoutes from "./components/AnonymousRoutes.jsx";
import CreateProperty from "./pages/property/CreateProperty.jsx";
const PropertyDetail = lazy(() =>
  import("./pages/property/PropertyDetail.jsx")
);
const EditPropertyPage = lazy(() =>
  import("./pages/property/EditProperty.jsx")
);
const LoginPage = lazy(() => import("./pages/LoginPage.jsx"));
const PropertyPage = lazy(() => import("./pages/property/PropertyPage.jsx"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage.jsx"));
const router = createBrowserRouter([
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <GalleryLayout />,
        children: [
          {
            path: "/",
            element: <Navigate to="/properties" replace />,
          },
          {
            path: "/properties/:id",
            element: (
              <Suspense fallback={<Spinner />}>
                <PropertyDetail />
              </Suspense>
            ),
          },
          {
            path: "/properties",
            element: (
              <Suspense fallback={<Spinner />}>
                <PropertyPage />
              </Suspense>
            ),
          },
          {
            path: "/properties/:id/edit",
            element: (
              <Suspense fallback={<Spinner />}>
                <EditPropertyPage />
              </Suspense>
            ),
          },
          {
            path: "/add-property",
            element: (
              <Suspense fallback={<Spinner />}>
                <CreateProperty />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    element: <AnonymousRoutes />,
    children: [
      {
        path: "/login",
        element: (
          <Suspense fallback={<Spinner />}>
            <LoginPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/not-found",
    element: (
      <Suspense fallback={<Spinner />}>
        <NotFoundPage />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/not-found" replace />,
  },
]);

const AppRouter = () => {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default AppRouter;
